import {
  ADMIN_CODE,
  APPS_AVAILABLE,
  APP_CODE_BRANCH,
  APP_CODE_ROOM,
  APP_CODE_TEXT_CHANNEL,
  EFFICE_ID_LENGTH,
  NONCE_EPOCH,
  NONCE_MS_COUNT,
} from "constants/constants";
import dayjs from "dayjs";
import Linkify from "react-linkify";

export const isPrivateEffice = (effice) => {
  return effice && effice.id === effice.permissions_id;
};

export const isRootEffice = (effice) => {
  return effice && effice.parent_id === null;
};

export const isNewMemberEffice = (effice) => {
  return effice && !effice.content;
};

export const isEfficeBranch = (effice) => {
  return effice?.pinned;
};

export const isTextNode = (effice) => {
  return effice && !isRootEffice(effice) && !isEfficeBranch(effice);
};

export const isBranchApp = (effice) => {
  return effice && effice.app_id === APP_CODE_BRANCH;
};

export const isTextChannel = (effice) => {
  return effice && effice.app_id === APP_CODE_TEXT_CHANNEL;
};

export const isSpace = (effice) => {
  return effice && effice.app_id === APP_CODE_ROOM;
};

export const nameThisNode = (effice) => {
  switch (effice?.app_id) {
    case APP_CODE_BRANCH:
      return isRootEffice(effice) ? "Effice" : "Branch";
    case APP_CODE_TEXT_CHANNEL:
      return "Channel";
    case APP_CODE_ROOM:
      return "Space";
    default:
      return "Thread";
  }
};

export const nameThisId = (theAppId) => {
  let theName = "thread";
  APPS_AVAILABLE.forEach(({ appId, name }) =>
    appId === theAppId ? (theName = name) : null
  );
  return theName;
};

export const suggestionForAppId = (theAppId) => {
  let theSuggestion = "any";
  APPS_AVAILABLE.forEach(({ appId, suggestion }) =>
    appId === theAppId ? (theSuggestion = suggestion) : null
  );
  return theSuggestion;
};

export const canIEdit = (effice, myRoleId, myId) => {
  return (
    (effice.pinned && myRoleId === ADMIN_CODE) ||
    (!effice.pinned && effice.creator.id === myId)
  );
};

export const iAmAdmin = (effice) => {
  if (!effice || effice.role_id === null || effice.role_id === undefined) {
    window.efs_debug && window.log("Role Id not found in this effice");
    return false;
  }
  return effice.role_id === ADMIN_CODE;
};

export function cleanEfficeList(efficeList) {
  let start = window.efs_debug && Date.now();
  efficeList.forEach((effice) => (effice = cleanEffice(effice)));
  window.efs_debug &&
    window.log(
      "Took " + (Date.now() - start).toString() + " to clean effice list."
    );
  return efficeList;
}
export function cleanEffice(effice) {
  if (effice.created_at) effice.created_at = adjustTime(effice.created_at);
  if (effice.editted_at) effice.editted_at = adjustTime(effice.editted_at);
  effice.id = adjustID(effice.id);
  if (effice.permissions_id)
    effice.permissions_id = adjustID(effice.permissions_id);
  if (effice.parent_id) effice.parent_id = adjustID(effice.parent_id);
  return effice;
}
function adjustTime(createdAt) {
  return dayjs(createdAt).format("DD/MM/YYYY-HH:mm");
}
export function adjustID(id) {
  return id.padStart(EFFICE_ID_LENGTH, "0");
}
export function unadjustID(id) {
  return id.replace(/^0+/, "");
}
export function getDateFromTimestamp(time) {
  return time.slice(0, 10);
}
export function getHourFromTimestamp(time) {
  return time.slice(11, 16);
}
export function determineNotify(subs, readSubs) {
  return subs && subs > 0 && (!readSubs || readSubs !== subs);
}
export function determineTextColor(efficeData) {
  return `Txt-effice-text ${
    efficeData.failed
      ? "Txt-failed-effice"
      : efficeData.pending
      ? "Txt-pending-effice"
      : ""
  }`;
}
let serverTimeOffset = 0;
export function setServerTime(serverUnixTimeSeconds) {
  serverTimeOffset = serverUnixTimeSeconds - Date.now();
  // will be inacurate depending on http request duration
}
export function makeNonce() {
  return adjustID(
    ((Date.now() + serverTimeOffset - NONCE_EPOCH) * NONCE_MS_COUNT).toString()
  );
}

window.makeNonce = makeNonce;
window.getServerTime = () => {
  window.efs_debug && window.log(serverTimeOffset);
};

const componentDecorator = (href, text, key) => (
  <a href={href} key={key} target="_blank" rel="noopener noreferrer">
    {text}
  </a>
);

export const LinkifyMe = ({ children }) => {
  return <Linkify componentDecorator={componentDecorator}>{children}</Linkify>;
};
